<!-- <button class="language-toggle" id="langToggle" (click)="onClick()">{{language === "English" ? "French" :
    "English"}}</button> -->

<label class="toggle-switch">
    <input type="checkbox" [checked]="isChecked" (change)="onToggleChange($event)">
    <span class="slider"></span>
    <span class="toggle-text" [ngClass]="isChecked?'justify-content-start ps-4':'justify-content-end pe-4'">{{ toggleText }}</span>
</label>